// TODO: Get rid of validate.js library in favor of simple stuff in util/validate.js

export const ERROR_MESSAGES = {
  EMPTY_NAME: "Please enter your name.",
  EMPTY_EMAIL: "Please enter your email.",
  INVALID_EMAIL: "Please enter a valid email.",
  NON_UNIQUE_EMAIL: "This email is already being used.",
  EMPTY_USERNAME: "Please enter a username.",
  INVALID_USERNAME: "Please enter a valid username.",
  SHORT_USERNAME: "Your username must be at least 5 characters long.",
  LONG_USERNAME: "Your username can be no more than 80 characters.",
  NON_UNIQUE_USERNAME: "This username is already being used.",
  EMPTY_PASSWORD: "Please enter a password.",
  SHORT_PASSWORD: "Your password must be at least 5 characters long.",
  LONG_PASSWORD: "Your password cannot be more than 128 characters.",
  INVALID_PASSWORD: "Passwords can only contain letters, numbers, or symbols—no spaces, etc.",
  EMPTY_PHONE: "Please enter your phone number.",
  INVALID_PHONE: "Please enter a valid phone number.",
  EMPTY_STATE: "Please select your state.",
  OLDER_UNCHECKED: "Please confirm your age.",
  AGREE_UNCHECKED: "Please agree to the Terms of Service.",
  TRY_AGAIN: "Whoops, something happened. Please refresh and try again."
}

import {single} from "validate.js"

export const validateValue = (v, constraint) => {
  const errors = single(v, constraint)
  return errors ? errors[0] : errors
}

export const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export const noErrors = (errors) => {
  return !errors.old && !errors.new
}

export const passwordConstraints = {
  old: {
    presence: {
      message: {
        en: "Enter your current password.",
        es: "Ingrese su contraseña actual"
      }
    }
  },
  new: {
    presence: {
      message: {
        en: "Enter your new password.",
        es: "Ingrese su nueva contraseña"
      }
    },
    length: {
      minimum: 5,
      message: {
        en: "Your password must be at least five characters long.",
        es: "Su contraseña debe tener por lo menos cinco carácteres o más."
      }
    }
  }
}

/**
 * Simple library-less validations
 */

export const isEmpty = (value) => value == ""

export const isChecked = (input) => input?.checked

const usernameTest = /^[a-zA-Z0-9-_.]+$/

export const isUsernameValid = (username) => username && usernameTest.test(username)

export const isUsernameTooShort = (username) => username && username.length < 5

export const isUsernameTooLong = (username) => username && username.length >= 64

export const Constants = {
  EMAIL_LENGTH: 254,
  PASSWORD_LENGTH: 60,
  NAME_LENGTH: 120,
  USERNAME_LENGTH: 100
}

const emailTest = /^(([^<>()[\]\\!.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const invalidPasswordCharacters = /^\S*$/

// Errors

export const isEmailValid = (email) => email && emailTest.test(email)

const isInvalidEmail = (form) => form.email && !isEmailValid(form.email)

const isInvalidParentEmail = (form) => form.parentEmail && !isEmailValid(form.parentEmail)

export const isPasswordTooShort = (form) => form.password && form.password.length < 5
export const isPasswordTooShort2 = (form) => form.password.length < 5

const isMissingName = (form) => !form.name || form.name.trim().length === 0

const isMissingUsername = (form) => !form.username

const isUsernameInvalid = (form) => !isUsernameValid(form.username)

const isMissingParentEmail = (form) => !form.parentEmail

const isMissingEmail = (form) => !form.email

const isMissingPassword = (form) => !form.password

const isMissingPhoneNumber = (form) => !form.phoneNumber

const isMissingState = (form) => !form.stateOfResidence

export const isPhoneNumberValid = (phoneNumber) => phoneNumber && phoneNumber.length === 10

const isInvalidPhoneNumber = (form) => !isPhoneNumberValid(form.phoneNumber)

const isMissingAgreementChecked = (form) => !form.agree

/* isMissingSource is currently not needed for NBPA this year, will most likely be used in the future */
const isMissingSource = (form) => form.subdomain === "nbpagrassroots" && !form.source

const isMissingZipCode = (form) => !form.zipCode

const isMissingSchool = (form) => !form.school

const isMissingUsernameOrEmail = (form) => !form.usernameOrEmail

// To not show multiple errors this fn now checks if username is valid, then checks if unique.
const isUsernameNotUnique = (form) => form.username && isUsernameValid(form.username) && form.isUsernameUnique === false

const isEmailNotUnique = (form) => form.email && isEmailValid(form.email) && form.isUsernameUnique === false

export const isInvalidPassword = (form) => form.password && !invalidPasswordCharacters.test(form.password)

export const loginHasErrors = (errors) => errors.usernameOrEmail.length > 0 || errors.password.length > 0

export const anyErrors = (errors) => {
  let ret = false
  for (const k in errors) {
    if (errors[k].length > 0) {
      ret = true
    }
  }
  return ret
}

export const validateMinorStudentSignupForm = (form) => {
  const errors = {
    isUsernameUnique: [],
    username: [],
    password: []
  }
  if (isMissingUsername(form)) {
    errors.username.push("missing-username")
  }
  if (isUsernameInvalid(form)) {
    errors.username.push("invalid-username")
  }
  if (isUsernameTooShort(form.username)) {
    errors.username.push("username-too-short")
  }
  if (isUsernameTooLong(form.username)) {
    errors.username.push("username-too-long")
  }
  if (isUsernameNotUnique(form)) {
    errors.isUsernameUnique.push("username-not-unique")
  }
  if (isMissingPassword(form)) {
    errors.password.push("missing-password")
  }
  if (isInvalidPassword(form)) {
    errors.password.push("invalid-password")
  }
  if (isPasswordTooShort(form)) {
    errors.password.push("password-too-short")
  }
  return errors
}

export const validateMajorStudentSignupForm = (form) => {
  const errors = {
    name: [],
    isUsernameUnique: [],
    username: [],
    password: []
  }
  if (isMissingName(form)) {
    errors.name.push("missing-name")
  }
  if (isMissingUsername(form)) {
    errors.username.push("missing-username")
  }
  if (isUsernameInvalid(form)) {
    errors.username.push("invalid-username")
  }
  if (isUsernameTooShort(form.username)) {
    errors.username.push("username-too-short")
  }
  if (isUsernameTooLong(form.username)) {
    errors.username.push("username-too-long")
  }
  if (isUsernameNotUnique(form)) {
    errors.isUsernameUnique.push("username-not-unique")
  }
  if (isMissingPassword(form)) {
    errors.password.push("missing-password")
  }
  if (isInvalidPassword(form)) {
    errors.password.push("invalid-password")
  }
  if (isPasswordTooShort(form)) {
    errors.password.push("password-too-short")
  }
  return errors
}

export const validateAdultDirectSignupForm = (form, options) => {
  const {collectPhone, collectState} = options
  const errors = {
    isUsernameUnique: [],
    name: [],
    email: [],
    password: [],
    phoneNumber: [],
    stateOfResidence: [],
    agree: [],
    source: []
  }
  if (isMissingName(form)) {
    errors.name.push("missing-name")
  }
  if (isMissingEmail(form)) {
    errors.email.push("missing-email")
  }
  if (isInvalidEmail(form)) {
    errors.email.push("invalid-email")
  }
  if (isEmailNotUnique(form)) {
    errors.isUsernameUnique.push("email-not-unique")
  }
  if (isMissingPassword(form)) {
    errors.password.push("missing-password")
  }
  if (isInvalidPassword(form)) {
    errors.password.push("invalid-password")
  }
  if (isPasswordTooShort(form)) {
    errors.password.push("password-too-short")
  }
  if (collectPhone && isMissingPhoneNumber(form)) {
    errors.phoneNumber.push("missing-phone-number")
  }
  if (collectPhone && isInvalidPhoneNumber(form)) {
    errors.phoneNumber.push("invalid-phone-number")
  }
  if (collectState && isMissingState(form)) {
    errors.stateOfResidence.push("missing-state")
  }
  if (isMissingAgreementChecked(form)) {
    errors.agree.push("missing-agreement")
  }
  return errors
}

export const validateChildDirectSignupForm = (form) => {
  const errors = {
    isUsernameUnique: [],
    username: [],
    parentEmail: [],
    password: [],
    agree: [],
    source: []
  }
  if (isMissingUsername(form)) {
    errors.username.push("missing-username")
  }
  if (isUsernameInvalid(form)) {
    errors.username.push("invalid-username")
  }
  if (isUsernameNotUnique(form)) {
    errors.isUsernameUnique.push("username-not-unique")
  }
  if (isMissingPassword(form)) {
    errors.password.push("missing-password")
  }
  if (isMissingParentEmail(form)) {
    errors.parentEmail.push("missing-parent-email")
  }
  if (isInvalidParentEmail(form)) {
    errors.parentEmail.push("invalid-parent-email")
  }
  if (isInvalidPassword(form)) {
    errors.password.push("invalid-password")
  }
  if (isPasswordTooShort(form)) {
    errors.password.push("password-too-short")
  }
  if (isMissingAgreementChecked(form)) {
    errors.agree.push("missing-agreement")
  }
  return errors
}

export const validateLoginForm = (form) => {
  const errors = {
    usernameOrEmail: [],
    password: []
  }
  if (isMissingUsernameOrEmail(form)) {
    errors.usernameOrEmail.push("missing-username-or-email")
  }
  if (isMissingPassword(form)) {
    errors.password.push("missing-password")
  }
  return errors
}
